var _path;

import * as React from "react";

function SvgInformationBoldCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.164 4 4 11.167 4 20c0 8.838 7.164 16 16 16s16-7.162 16-16c0-8.833-7.164-16-16-16zm0 28.903c-7.131 0-12.903-5.77-12.903-12.903 0-7.129 5.772-12.903 12.903-12.903 7.128 0 12.903 5.772 12.903 12.903S27.133 32.903 20 32.903zm0-21.806a2.71 2.71 0 110 5.42 2.71 2.71 0 010-5.42zm3.613 16.387a.774.774 0 01-.774.774H17.16a.774.774 0 01-.774-.774v-1.549c0-.427.347-.774.774-.774h.774v-4.129h-.774a.774.774 0 01-.774-.774V18.71c0-.428.347-.774.774-.774h4.13c.427 0 .773.346.773.774v6.451h.775c.427 0 .774.347.774.774v1.549z"
  })));
}

export default SvgInformationBoldCircle;